// src/pages/Accommodation.js
// ──────────────────────────────────────────────────────────────────────────
// On-campus boarding — Lake Chila. The "Visit Lake Chila" button currently
// points to a Google Maps location as a placeholder; replace LAKE_CHILA_URL
// with the actual Lake Chila boarding site, and add real boarding houses
// to the HOUSES array when ready.
// ──────────────────────────────────────────────────────────────────────────

import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import theme from '../theme/theme';

const LAKE_CHILA_URL = 'https://www.google.com/maps/search/Lake+Chila+Mbala+Zambia';

const Header = styled.header`
  background: ${theme.color.blueDeep}; color: #fff;
  padding: 7rem ${theme.layout.gutter} 5rem;
  .inner { max-width: ${theme.layout.maxWidth}; margin: 0 auto; }
  h1 { font-weight: 400; font-size: clamp(2.4rem, 6vw, 4rem); color: #fff; margin-top: 1.2rem; }
  p { margin-top: 1rem; max-width: 54ch; font-weight: 300; color: rgba(255,255,255,0.82); }
  .kicker { color: #fff; }
`;
const Section = styled.section` max-width: ${theme.layout.maxWidth}; margin: 0 auto; padding: 5rem ${theme.layout.gutter}; `;

const Hero = styled.a`
  display: block; position: relative; min-height: 62vh; border-radius: ${theme.layout.radius};
  overflow: hidden; margin-top: 2.5rem; color: #fff;
  background-image: ${theme.gradient.heroScrim},
    url('https://images.unsplash.com/photo-1439066615861-d1af74d74000?auto=format&fit=crop&q=80&w=2400');
  background-size: cover; background-position: center;
  transition: transform 0.4s ${theme.ease}, box-shadow 0.4s ${theme.ease};
  &:hover { box-shadow: 0 30px 60px -28px rgba(11,42,99,0.5); }
  &:hover .go { letter-spacing: 0.04em; }
  .inner { position: absolute; left: 0; bottom: 0; padding: clamp(2rem, 5vw, 3.5rem); max-width: 640px; }
  .k { font-size: 0.74rem; font-weight: 700; letter-spacing: 0.16em; text-transform: uppercase; color: #fff; opacity: 0.9; }
  h2 { font-weight: 400; font-size: clamp(2.4rem, 7vw, 4.4rem); color: #fff; margin: 0.6rem 0 0.8rem; }
  p { font-weight: 300; color: rgba(255,255,255,0.88); max-width: 44ch; margin: 0 0 1.4rem; }
  .go { display: inline-flex; align-items: center; gap: 8px; background: ${theme.color.lemon}; color: ${theme.color.onLemon};
        font-weight: 700; font-size: 0.86rem; padding: 12px 24px; border-radius: ${theme.layout.radius}; transition: gap 0.3s ${theme.ease}; }
`;

const Note = styled.div`
  margin-top: 2.5rem; padding: 1.6rem 1.8rem; border-left: 4px solid ${theme.color.lemon};
  background: ${theme.color.paperAlt}; border-radius: ${theme.layout.radius}; color: ${theme.color.inkSoft};
`;

function Accommodation() {
  return (
    <>
      <Navbar />
      <Header>
        <div className="inner">
          <span className="kicker">Where you'll stay</span>
          <h1>Accommodation</h1>
          <p>MTI offers on-campus boarding at Lake Chila — a calm lakeside setting, close to your training and the institute community.</p>
        </div>
      </Header>

      <Section>
        <Hero href={LAKE_CHILA_URL} target="_blank" rel="noreferrer">
          <div className="inner">
            <span className="k">On-campus boarding</span>
            <h2>Lake Chila</h2>
            <p>Boarding for MTI students by the shores of Lake Chila in Mbala — calm, close to campus, and part of the community.</p>
            <span className="go">Visit Lake Chila ↗</span>
          </div>
        </Hero>

        <Note>
          Individual boarding houses and room details are coming soon. For availability and bookings in the
          meantime, please <Link to="/contact" style={{ color: theme.color.accent, fontWeight: 600 }}>contact us</Link>.
        </Note>
      </Section>

      <Footer />
    </>
  );
}

export default Accommodation;
